import { render } from "./EmisionResumen.vue?vue&type=template&id=3596b999&scoped=true"
import script from "./EmisionResumen.vue?vue&type=script&lang=js"
export * from "./EmisionResumen.vue?vue&type=script&lang=js"

import "./EmisionResumen.vue?vue&type=style&index=0&id=3596b999&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3596b999"]])

export default __exports__